module.exports = __webpack_public_path__ + "img/3-4.780e98eb.svg";